import { PlateFloatingLink } from '@udecode/plate';
const linkPlugin = {
    // @ts-expect-error ignore for now
    renderAfterEditable: PlateFloatingLink,
};
export default linkPlugin;
//# sourceMappingURL=linkPlugin.js.map